import type { SerializedError } from '@reduxjs/toolkit'
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { formatError } from '@tunasong/redux'
import { Typography } from '@tunasong/ui-lib'
import type { FC, JSX } from 'react'
import { Browser } from 'react-kawaii'
import styles from './error-message.module.css'

export interface ErrorMessageProps {
  message?: string | JSX.Element
  rtkQueryError?: SerializedError | FetchBaseQueryError
}
export const ErrorMessage: FC<ErrorMessageProps> = props => {
  const { message = 'Whops. Something went wrong.', rtkQueryError } = props

  const rtkQueryErrorText = rtkQueryError ? formatError(rtkQueryError) : null

  const text = rtkQueryErrorText ?? message

  return (
    <div className={styles.container}>
      <Browser size={200} mood="sad" color={'var(--tuna-palette-secondary-main)'} />
      <Typography variant="subtitle1">{text}</Typography>
    </div>
  )
}
